import { useAtomData } from '@lighthouse/shared'
import React from 'react'
import { createPortal } from 'react-dom'

import { dataDrawerStateAtom } from '@/atoms/application/state'

import { PageDataDrawer } from './PageDataDrawer'
import { PageFooterToolBar } from './PageFooterToolBar'

export const PageFooter: React.FC = () => {
    const visible = useAtomData(dataDrawerStateAtom)

    return (
        <>
            {visible && createPortal(<PageDataDrawer />, document.body)}
            <PageFooterToolBar />
        </>
    )
}
